<template>
  <div class="py-3 text-center">
    <span class="text-muted small font-weight-bolder">{{ $t('login.version') }} {{ version }}</span>
  </div>
</template>

<script>
import {version} from '@client/package.json'

export default {
  data (){
    return {
      version
    }
  }
}
</script>

